import React from 'react';
import CSVReader from 'react-csv-reader'
import {InputType} from '../../components/input/input.component';
import {DropDown} from '../../components/dropdown/dropdown.component';



class Sparkline extends React.Component {
    constructor(){
          super();
          this.state = {
            data: [33515308, 22992517, 15214030, 5780379], 
            dataType: null,
            isManualError: false,
          }
       }
    isObjectEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return true;
        }
        return false;
    }
    handleDropDownChange = (dataType)=>{
        this.setState({dataType: dataType, data: {}})
      }

    handleInputChange=(event)=> {
        let currData = event.target.value.split(",")
        let finalData = []
        for(let i=0; i<currData.length; i++) {
          if(i<currData.length-1 || parseInt(currData[i]))
            finalData.push(parseInt(currData[i]));
        }
        this.setState({data: finalData})
      }
    handleCSVUpload = (data, _)=> {
        let chartData = [];
        for(let i=0; i<data[0].length; i+=1) {
          chartData.push(parseInt(data[0][i]));
        }
        this.setState({data: chartData})
      }
    sparkline = function(series){
        let spark_chars = "▁▂▃▄▅▆▇█"
        let mn = Math.min.apply(Math, series)
        let mx = Math.max.apply(Math, series)
        let interval = Math.ceil((mx-mn)/7)
        let bucketed = []
        for(let i=0; i<series.length; i++) {
            bucketed.push(parseInt((series[i]-mn)/interval ))
        }
        let spark_dict = {}
        for(let i=0; i<8; i++) {
            spark_dict[i] = spark_chars[i]
        }
        let z = []
        for(let i=0; i<bucketed.length; i++) {
            z.push(spark_dict[bucketed[i]])
        }
        let separator;
        return z.join([separator=""])
      }
      createGraph = ()=>{
        let graph = this.sparkline(this.state.data);
        this.setState({graph: graph});
      }
    componentDidMount(){
      this.createGraph();
    }
    render() {
        let dataEntryType = null, graph=null;
        dataEntryType = <div className="col-4"> <InputType type="text" id="inputValues" placeholder="33515308, 22992517, 15214030, 5780379" label="Values" name="values" handleInputChange={this.handleInputChange} /> </div>
        
        return (
          <div className="container graph">
            <div className="row">
            <h3 className="col-2">Sparkline</h3>
            {dataEntryType}
            <div className="col-2"><button className="btn btn-primary " onClick={this.createGraph}>Get chart</button></div>
            {this.state.graph ? <pre className="col-3">{this.state.graph}</pre>:<p className="col-3">No data exists</p> } 

        </div>
        </div>);

        }
}


export default Sparkline;